import styled from 'styled-components'
import { Row } from '@gympass/yoga'

import { H2, H3, H4, H6, Paragraph } from '@components/Text'
import SMBContainer from '@components/Container'

import tokens from '@gympass/yoga-tokens'

import getBreakpoint from '@client/utils/breakpoints'

export const Container = styled(SMBContainer)`
  @media (min-width: ${getBreakpoint('md')}px) and (max-width: ${getBreakpoint(
      'lg'
    )}px) {
    max-width: 479px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const WrapperTitle = styled(Row)`
  padding: 40px 0 50px 0;
`
export const Header = styled.header`
  background-color: var(--vila-olimpia-10);
`

export const Title = styled(H3)`
  font-style: normal;
  font-weight: 500;
  line-height: 38px;
  margin-top: 24px;
`

export const Subtitle = styled(Paragraph)`
  font-weight: normal;
  line-height: 24px;
  margin-top: 10px;
  color: ${tokens.colors.deep};

  strong {
    margin-left: 4px;
  }
`

export const DownloadButton = styled.section`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 32px;
`

export const DownloadButtonDescription = styled(Paragraph)`
  flex: 1;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-left: 8px;
  font-size: 14px;

  color: var(--vibin);
`

export const IllustrationWrapper = styled.section`
  margin: 113px auto 86px;
  width: 120px;
`

export const NextSteps = styled.section`
  padding-top: 72px;
  padding-bottom: 72px;
  background-color: var(--white);

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    padding-top: 96px;
    padding-bottom: 84px;
  }
`

export const SectionTitle = styled(H2)`
  line-height: 36px;
  font-weight: 500;
`

export const NextStepItem = styled.section`
  display: flex;
  align-items: center;
  margin-top: 40px;
  color: ${tokens.colors.deep};

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-top: 44px;
  }
`

export const NextStepIcon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 100px;
  background-color: #ffb0a740;
  color: ${tokens.colors.brandingVerve};
  font-weight: 500;
  font-size: 30px;
  padding: 4px 16px;
`

export const NextStepDescription = styled(H4)`
  font-weight: normal;
  line-height: 32px;
  margin-left: 16px;
  font-size: 18px;

  a {
    text-decoration: none;
    font-weight: 500;
    color: var(--vibin);
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-left: 30px;
  }
`

export const Payment = styled.section`
  padding-top: 72px;
  padding-bottom: 48px;
  background-color: var(--vila-olimpia-10);

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    padding-top: 96px;
    padding-bottom: 72px;
  }
`

export const PaymentDescriptionWrapper = styled.section`
  margin-top: 36px;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-top: 32px;
  }
`

export const PaymentDescription = styled(H6)`
  font-weight: normal;
  line-height: 24px;
  margin-bottom: 24px;
  color: ${tokens.colors.deep};
`
